import { render, staticRenderFns } from "./DiscountLimit.vue?vue&type=template&id=234dfd72&scoped=true&"
import script from "./DiscountLimit.vue?vue&type=script&lang=js&"
export * from "./DiscountLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234dfd72",
  null
  
)

export default component.exports